import { Input } from '@/components/ui/input';

interface PaymentSkipSettingsProps {
    allowPaymentSkip: boolean;
    maxSkipsAllowed: string;
    skipFeeAmount: string;
    skipResetsAnnually: boolean;
    onChange: (field: string, value: string | boolean) => void;
}

export function PaymentSkipSettings({ allowPaymentSkip, maxSkipsAllowed, skipFeeAmount, skipResetsAnnually, onChange }: PaymentSkipSettingsProps) {
    return (
        <div className="space-y-3">
            <label className="flex items-center gap-2 text-sm">
                <input
                    type="checkbox"
                    checked={allowPaymentSkip}
                    onChange={e => onChange('allow_payment_skip', e.target.checked)}
                    className="rounded border-slate-600"
                />
                Enable Hard Times Payment Skip
            </label>

            {allowPaymentSkip && (
                <div className="grid grid-cols-2 gap-3 pl-6">
                    <div>
                        <label className="mb-1 block text-xs text-slate-400">Max Skips Allowed</label>
                        <Input
                            type="number"
                            min="1"
                            max="52"
                            value={maxSkipsAllowed}
                            onChange={e => onChange('max_skips_allowed', e.target.value)}
                        />
                    </div>
                    <div>
                        <label className="mb-1 block text-xs text-slate-400">Skip Fee ($)</label>
                        <Input
                            type="number"
                            min="0"
                            step="0.01"
                            value={skipFeeAmount}
                            onChange={e => onChange('skip_fee_amount', e.target.value)}
                            placeholder="0.00"
                        />
                    </div>
                    <label className="col-span-2 flex items-center gap-2 text-xs text-slate-400">
                        <input
                            type="checkbox"
                            checked={skipResetsAnnually}
                            onChange={e => onChange('skip_resets_annually', e.target.checked)}
                            className="rounded border-slate-600"
                        />
                        Reset skip count annually
                    </label>
                </div>
            )}
        </div>
    );
}
